// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content/Tags/Content/mutation-create-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_CheckRequirements_Requirement_NewTask_Content_Tags_Content($name: String!) {
  insert_tasks_tags_one(object: { type: TASK, name: $name }) {
    id
    name
  }
}

`